// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.descriptionContainer_h6fcr {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.descWraper_BOzOG {
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 12px;
}
.meetDescWrapper_PPvao {
	display: flex;
	flex-direction: row;
	width: 100%;
	align-items: flex-start;
	gap: 10px;
	margin-top: 0.5px;
	border-radius: 6px;
	padding: 0px 8px;
	transition: background 0.2s ease-in-out;
	border: 1px solid var(--border-color);
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	min-height: 46px;
}

.attachButtonWrapper_nycKc {
	display: flex;
	flex-direction: row;
	gap: 12px;
	align-items: center;
	justify-content: flex-start;
}

.meetAttachButtonWrapper_xngHT {
	display: flex;
	flex-direction: row;
	gap: 12px;
	align-items: center;
	justify-content: flex-start;
	height: 46px;
	border-radius: 5px;
	transition: background 0.2s ease-in-out;
	border: 1px solid var(--border-color);
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
}
.meetAttachButtonWrapperActive_I_mhm {
	display: flex;
	flex-direction: row;
	gap: 12px;
	align-items: center;
	justify-content: flex-start;
	height: 46px;
	border-radius: 5px;
	transition: background 0.2s ease-in-out;
	border: 1px solid var(--_16c09821-background);
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	background-color: var(--_16c09821-background);
	&:hover {
		background-color: var(--e6fff9-background);
	}
}
.meetAttachButton_Lsbgb {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 44px;
	border-radius: 5px;
	color: var(--text-color-secondary);
	padding: 0px 8px;
}
.meetAttachButtonActive_RfdXc {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 44px;
	border-radius: 5px;
	color: var(--white-color);
	padding: 0px 8px;
}
.attachButton_cSxLB {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 35px;
	border-radius: 5px;
	color: var(--text-color-secondary);
	padding: 0px 8px;
	transition: background 0.2s ease-in-out;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	&:hover {
		background-color: var(--f5-background);
	}
}

.descriptionMultiLineInputContainer_NpdJl {
	display: flex;
	border-radius: 7px;
	padding: 5px 8px;
	width: 100%;
	max-width: 400px;
	box-sizing: border-box;
	max-height: 250px;
	overflow-y: auto;
}
.meetDescriptionMultiLineInputContainer_PAYIu {
	display: flex;
	border-radius: 7px;
	width: 100%;
	max-width: 400px;
	box-sizing: border-box;
	max-height: 250px;
	overflow-y: auto;
}
.normalIcon_emIvG {
	margin-left: 2px;
	margin-right: -2px;
}

.descriptionTextarea_Qj1MR {
	width: 100%;
	border: none !important;
	background: none !important;
	outline: none !important;
	resize: none;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	min-height: 20.5px !important;
	max-height: 250px; 
	color: var(--text-secondary);
	font-size: 16px;
	line-height: 1.2;
}
.meetDescriptionTextarea_fMtX7 {
	width: 100%;
	border: none !important;
	background: none !important;
	outline: none !important;
	resize: none;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 10px;
	padding-left: 7px;
	min-height: 38px !important;
	max-height: 250px;
	color: var(--_3c3a3a-color) !important;
	font-size: 16px;
	font-weight: 400 !important;
	line-height: 1.5;
}
.attachmentInfo_ToME8 {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 15px;
	p {
		color: var(--_10a37f-background);
	}
	button {
		border-radius: 5px;
		padding: 4px 8px;
		background-color: var(--_16c0982e-background);
		transition: background 0.2s ease-in-out;
		font-size: 12px;
		color: var(--f5-background);
		&:hover {
			background-color: var(--_16c0982e-background);
		}
	}
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/CustomDescriptionInput.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,SAAS;AACV;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,uBAAuB;CACvB,SAAS;CACT,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,uCAAuC;CACvC,qCAAqC;CACrC,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,mBAAmB;CACnB,2BAA2B;CAC3B,YAAY;CACZ,kBAAkB;CAClB,uCAAuC;CACvC,qCAAqC;CACrC,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,mBAAmB;CACnB,2BAA2B;CAC3B,YAAY;CACZ,kBAAkB;CAClB,uCAAuC;CACvC,6CAA6C;CAC7C,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,6CAA6C;CAC7C;EACC,0CAA0C;CAC3C;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,kBAAkB;CAClB,kCAAkC;CAClC,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,kBAAkB;CAClB,kCAAkC;CAClC,gBAAgB;CAChB,uCAAuC;CACvC,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB;EACC,sCAAsC;CACvC;AACD;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;CAChB,sBAAsB;CACtB,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,kBAAkB;CAClB,WAAW;CACX,gBAAgB;CAChB,sBAAsB;CACtB,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,uBAAuB;CACvB,2BAA2B;CAC3B,wBAAwB;CACxB,YAAY;CACZ,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,6BAA6B;CAC7B,iBAAiB;CACjB,4BAA4B;CAC5B,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,uBAAuB;CACvB,2BAA2B;CAC3B,wBAAwB;CACxB,YAAY;CACZ,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;CACjB,iBAAiB;CACjB,2BAA2B;CAC3B,iBAAiB;CACjB,sCAAsC;CACtC,eAAe;CACf,2BAA2B;CAC3B,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,SAAS;CACT;EACC,gCAAgC;CACjC;CACA;EACC,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,uCAAuC;EACvC,eAAe;EACf,2BAA2B;EAC3B;GACC,6CAA6C;EAC9C;CACD;AACD","sourcesContent":[".descriptionContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n}\n\n.descWraper {\n\tdisplay: flex;\n\tflex-direction: row;\n\twidth: 100%;\n\tgap: 12px;\n}\n.meetDescWrapper {\n\tdisplay: flex;\n\tflex-direction: row;\n\twidth: 100%;\n\talign-items: flex-start;\n\tgap: 10px;\n\tmargin-top: 0.5px;\n\tborder-radius: 6px;\n\tpadding: 0px 8px;\n\ttransition: background 0.2s ease-in-out;\n\tborder: 1px solid var(--border-color);\n\tcursor: pointer;\n\tuser-select: none;\n\tmin-height: 46px;\n}\n\n.attachButtonWrapper {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 12px;\n\talign-items: center;\n\tjustify-content: flex-start;\n}\n\n.meetAttachButtonWrapper {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 12px;\n\talign-items: center;\n\tjustify-content: flex-start;\n\theight: 46px;\n\tborder-radius: 5px;\n\ttransition: background 0.2s ease-in-out;\n\tborder: 1px solid var(--border-color);\n\tcursor: pointer;\n\tuser-select: none;\n}\n.meetAttachButtonWrapperActive {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 12px;\n\talign-items: center;\n\tjustify-content: flex-start;\n\theight: 46px;\n\tborder-radius: 5px;\n\ttransition: background 0.2s ease-in-out;\n\tborder: 1px solid var(--_16c09821-background);\n\tcursor: pointer;\n\tuser-select: none;\n\tbackground-color: var(--_16c09821-background);\n\t&:hover {\n\t\tbackground-color: var(--e6fff9-background);\n\t}\n}\n.meetAttachButton {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 44px;\n\tborder-radius: 5px;\n\tcolor: var(--text-color-secondary);\n\tpadding: 0px 8px;\n}\n.meetAttachButtonActive {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 44px;\n\tborder-radius: 5px;\n\tcolor: var(--white-color);\n\tpadding: 0px 8px;\n}\n.attachButton {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 35px;\n\tborder-radius: 5px;\n\tcolor: var(--text-color-secondary);\n\tpadding: 0px 8px;\n\ttransition: background 0.2s ease-in-out;\n\tcursor: pointer;\n\tuser-select: none;\n\t&:hover {\n\t\tbackground-color: var(--f5-background);\n\t}\n}\n\n.descriptionMultiLineInputContainer {\n\tdisplay: flex;\n\tborder-radius: 7px;\n\tpadding: 5px 8px;\n\twidth: 100%;\n\tmax-width: 400px;\n\tbox-sizing: border-box;\n\tmax-height: 250px;\n\toverflow-y: auto;\n}\n.meetDescriptionMultiLineInputContainer {\n\tdisplay: flex;\n\tborder-radius: 7px;\n\twidth: 100%;\n\tmax-width: 400px;\n\tbox-sizing: border-box;\n\tmax-height: 250px;\n\toverflow-y: auto;\n}\n.normalIcon {\n\tmargin-left: 2px;\n\tmargin-right: -2px;\n}\n\n.descriptionTextarea {\n\twidth: 100%;\n\tborder: none !important;\n\tbackground: none !important;\n\toutline: none !important;\n\tresize: none;\n\toverflow: hidden;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 14px;\n\tmin-height: 20.5px !important;\n\tmax-height: 250px; \n\tcolor: var(--text-secondary);\n\tfont-size: 16px;\n\tline-height: 1.2;\n}\n.meetDescriptionTextarea {\n\twidth: 100%;\n\tborder: none !important;\n\tbackground: none !important;\n\toutline: none !important;\n\tresize: none;\n\toverflow: hidden;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding-top: 10px;\n\tpadding-left: 7px;\n\tmin-height: 38px !important;\n\tmax-height: 250px;\n\tcolor: var(--_3c3a3a-color) !important;\n\tfont-size: 16px;\n\tfont-weight: 400 !important;\n\tline-height: 1.5;\n}\n.attachmentInfo {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 15px;\n\tp {\n\t\tcolor: var(--_10a37f-background);\n\t}\n\tbutton {\n\t\tborder-radius: 5px;\n\t\tpadding: 4px 8px;\n\t\tbackground-color: var(--_16c0982e-background);\n\t\ttransition: background 0.2s ease-in-out;\n\t\tfont-size: 12px;\n\t\tcolor: var(--f5-background);\n\t\t&:hover {\n\t\t\tbackground-color: var(--_16c0982e-background);\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"descriptionContainer": `descriptionContainer_h6fcr`,
	"descWraper": `descWraper_BOzOG`,
	"meetDescWrapper": `meetDescWrapper_PPvao`,
	"attachButtonWrapper": `attachButtonWrapper_nycKc`,
	"meetAttachButtonWrapper": `meetAttachButtonWrapper_xngHT`,
	"meetAttachButtonWrapperActive": `meetAttachButtonWrapperActive_I_mhm`,
	"meetAttachButton": `meetAttachButton_Lsbgb`,
	"meetAttachButtonActive": `meetAttachButtonActive_RfdXc`,
	"attachButton": `attachButton_cSxLB`,
	"descriptionMultiLineInputContainer": `descriptionMultiLineInputContainer_NpdJl`,
	"meetDescriptionMultiLineInputContainer": `meetDescriptionMultiLineInputContainer_PAYIu`,
	"normalIcon": `normalIcon_emIvG`,
	"descriptionTextarea": `descriptionTextarea_Qj1MR`,
	"meetDescriptionTextarea": `meetDescriptionTextarea_fMtX7`,
	"attachmentInfo": `attachmentInfo_ToME8`
};
export default ___CSS_LOADER_EXPORT___;
